import(/* webpackMode: "eager", webpackExports: ["ChristmasOfferingPageClient"] */ "/vercel/path0/apps/web/app/(app)/o/[offeringId]/ChristmasOfferingPageClient.tsx");
